import { render, staticRenderFns } from "./MultipleChoiceDateTest.vue?vue&type=template&id=72bb4551&scoped=true&"
import script from "./MultipleChoiceDateTest.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceDateTest.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceDateTest.vue?vue&type=style&index=0&id=72bb4551&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb4551",
  null
  
)

export default component.exports